import { StorageManager } from 'legacy/DFE/utils/storage';
import { Language } from 'legacy/DFE/types/Language';

export const getCurrentLanguage = (): string => {
  return StorageManager.get('language') || Language.en;
};
